import './StatusHoldReleaseForm.scss'

import React from 'react'
import { connect } from 'react-redux'
import Select from 'react-select'
import { createStructuredSelector } from 'reselect'
import { scrollToTop } from 'manager/util/helper'

import FeedbackFormField from 'common/views/components/FormField'
import { LONG_TERM_HOLD, ANDROID } from 'common/constants'

import { saveStatus, updateHoldTerm, updateNote } from 'manager/redux/referral_status'
import { StatusSubmitButton } from './StatusSubmitButton'
import { selectHoldTerm, selectNote } from 'manager/selectors/referral_status_selectors'
import { selectIsReferralRecent } from 'manager/selectors/referral_selectors'
import { isEmbedded, deviceType } from 'common/util/features'

const HoldForm = ({hold_term, note, updateHoldTerm, updateNote, saveStatus, isRecentAssignment}) => {

  const onSubmit = () => {
    saveStatus({
        action: 'long-term-hold',
        payload: { hold_term, note },
    })
  }

  const useNativeSelect = isEmbedded() && deviceType() == ANDROID

  return <div className='StatusHoldReleaseForm'>
    <div className='StatusHoldReleaseForm__content'>
      <div className='StatusHoldReleaseForm__description'>
        If a referral needs an extended amount of time before moving forward, you can put it on hold.
      </div>
      { isRecentAssignment &&
        <div className='StatusHoldReleaseForm__recently_claimed'>
          <div className='StatusHoldReleaseForm__recently_claimed__title'>
            It looks like you recently claimed this referral.
          </div>
          <div className='StatusHoldReleaseForm__recently_claimed__description'>
            Placing a referral on hold before the one month mark can drastically reduce the chance of a close. We encourage you to continue pursuing this connection and update their status weekly.
          </div>
        </div>
      }
      <div className="StatusHoldReleaseForm__fields">
        <FeedbackFormField className='StatusHoldReleaseForm__select' label='Hold duration' isRequired>
          {useNativeSelect ? (
            <div className='StatusHoldReleaseForm__select--native' >
              <select value={hold_term} onChange={({ currentTarget }) => updateHoldTerm(currentTarget && currentTarget.value)}>
                <option hidden key={-1} value={null}></option>
                {LONG_TERM_HOLD.map(({ label, value }) => {
                  return (
                    <option key={value} value={value}>
                      { label }
                    </option>
                  )
                })}
              </select>
            </div>
          ) : (
            <Select
              options={LONG_TERM_HOLD}
              value={hold_term}
              clearable={false}
              onChange={evt => updateHoldTerm(evt.value)}
          />)}
        </FeedbackFormField>
        <FeedbackFormField className='StatusHoldReleaseForm__textfield' label="Note" isRequired>
          <textarea className="form-control" onChange={evt => updateNote(evt.target.value)} value={note} onFocus={scrollToTop} />
        </FeedbackFormField>
      </div>
    </div>
    <StatusSubmitButton
      disabled={(!hold_term || !note)}
      onClick={onSubmit}>
      Place on long term hold
    </StatusSubmitButton>
  </div>
}

const selector = createStructuredSelector({
  note: selectNote,
  hold_term: selectHoldTerm,
  isRecentAssignment: selectIsReferralRecent,
})

const actions = { updateHoldTerm, updateNote, saveStatus }

export const StatusHoldForm = connect(selector, actions)(HoldForm)
